<template>
    <div class="my-5">
        {{ label }}
        <v-progress-linear
            color="white"
            :buffer-value="value"
            stream
            rounded
            height="8" />
    </div>
</template>

<script>
export default {
    name: 'SkillBar',
    props: {
        label: { type: String, required: true },
        value: { type: Number, required: true },
    },
};
</script>
